module.exports = __webpack_public_path__ + "img/left.91bf58f3.svg";